import { getRangeTime } from '../../features/Bookings/utils';
import { TimeRange } from '../AdminBookings/utils';

export const TRAIN_AHEAD_OPTIONS = [
  { label: 'месяц', value: 30 },
  { label: '3 месяца', value: 60 },
  { label: 'год', value: 365 },
  { label: 'x', value: 0 },
];

export const DAYS_OPTIONS = [
  { label: 'Пн', value: 'День-1' },
  { label: 'Вт', value: 'День-2' },
  { label: 'Ср', value: 'День-3' },
  { label: 'Чт', value: 'День-4' },
  { label: 'Пт', value: 'День-5' },
  { label: 'Сб', value: 'День-6' },
  { label: 'Вс', value: 'День-0' },
];

export interface AdminTrainingFormData {
  coach_id: number;
  day: Date;
  days: { [key: string]: boolean };
  end_time_id: number;
  place_id: number;
  quantity: number;
  info: string;
  start_time_id: number;
  subscription_id: number;
  tables: { [key: string]: boolean | null };
}

export const getTablesByPlace = (
  date: Date,
  place_id: number,
  timeRangesMap: Map<string, TimeRange[]>,
) => {
  if (!date || !place_id) return [];
  const formatedDate = date.toLocaleDateString('ru-RU');
  if (timeRangesMap.get(`${place_id}-${formatedDate}`)) {
    return timeRangesMap
      .get(`${place_id}-${formatedDate}`)[0]
      ?.tables?.map((table) => ({ value: table.id, label: table.table_number }));
  }
};

export const getTimeOptions = (
  date: Date,
  place_id: number,
  timeRangesMap: Map<string, TimeRange[]>,
) => {
  if (!date || !place_id) return { start: [], end: [] };
  const formatedDate = date.toLocaleDateString('ru-RU');
  const options: {
    start: { label: string; value: number }[];
    end: { label: string; value: number }[];
  } = { start: [], end: [] };
  if (timeRangesMap.get(`${place_id}-${formatedDate}`)) {
    const timeRanges = timeRangesMap.get(`${place_id}-${formatedDate}`);

    for (let index = 0; index < timeRanges.length; index++) {
      const timeRange = timeRanges[index];
      options.start.push({ label: getRangeTime(timeRange.start), value: timeRange.id });
      options.end.push({ label: getRangeTime(timeRange.end), value: timeRange.id });
    }
  }
  return options;
};

export interface TransactionStatus {
  order_id: number;
  payment_id: number;
  total_price: number;
  type: string;
}
